import React, { ComponentProps, useState } from "react";
import { Button } from "@clarkinc/zest-design-system/ui";
import { cls } from "@wss/cls";
import RecommendedItem from "./components/RecommendedItem";
import Skeleton from "../Skeleton";
import { Category as CategoryData } from "./contracts";
interface CategoryProps extends CategoryData {
  loading?: boolean;
}
const PAGE_SIZE = 4;
const Category = ({
  className,
  loading = true,
  categoryName,
  items = []
}: CategoryProps & ComponentProps<"div">) => {
  const [page, setPage] = useState(1);
  const start = page * PAGE_SIZE - PAGE_SIZE;
  const handleSeeMore = () => {
    if (page * PAGE_SIZE >= items.length) {
      setPage(1);
    } else setPage(page + 1);
  };
  const missingItems = Math.max(0, PAGE_SIZE - items.slice(start, start + PAGE_SIZE).length);
  return <div className={cls("grid",
  // this is required to make the container border work correctly. I don't know why
  "w-full h-full box-border min-w-[298px] p-4 border border-solid border-[#f1f1f1] rounded-md shadow-[0_1px_3px_rgba(0,0,0,0.1)] mb-1/2", "xl:min-w-[288px] xl:h-auto", className)} data-sentry-component="Category" data-sentry-source-file="Category.tsx">
      <div className="flex justify-between w-full pb-3 items-start">
        {loading && <div className="w-full xl:h-8" data-testid="skeleton-category">
            <Skeleton className="xl:w-[70%] h-5" />
          </div> || <>
            <span className="font-bold text-xl leading-5">{categoryName}</span>
            <Button className="ml-4 outline-none whitespace-nowrap" variant="plain" onClick={handleSeeMore} data-testid="see-more-button">
              See More
            </Button>
          </>}
      </div>
      <div className={cls("grid grid-cols-2 gap-x-4 gap-y-4-1/2 items-start", "xl:gap-x-2 xl:gap-y-3", "xxxsl:gap-4")}>
        {items.slice(start, start + PAGE_SIZE).map(item => <RecommendedItem loading={loading} {...item} />)}
        {Array.from({
        length: missingItems
      }).map(() => <div className=" h-[192px]"></div>)}
      </div>
    </div>;
};
export default Category;